{
  "upload": {
    "heading": "Añadir fotos",
    "description": "A cada foto le corresponderá un solo producto",
    "choose": "Elegir fotos",
    "photoSelected": "{ {count} foto seleccionada",
    "photoSelected_plural": "{ {count} fotos seleccionadas",
    "maxPhotos": "Puedes seleccionar hasta %d foto",
    "maxPhotos_plural": "Puedes seleccionar hasta %d fotos",
    "continue": "Continuar",
    "back": "Atrás",
    "loading-description": "Estamos subiendo tus fotos...",
    "more-purchase-less-price": "Cuantos más cuadros pidas, menos te gastas",
    "how-many-frames": "¿Cuántos cuadros quieres añadir?",
    "description-mobile": "A cada foto le corresponderá un solo producto.",
    "title": "Arrastra y suelta tus fotos aquí",
    "subheading": "Puedes seleccionar hasta 360 fotos",
    "title-mobile": "Sube desde la galería de tu móvil",
    "choose-or-take": "Elegir o sacar una foto",
    "computer": "Ordenador",
    "google-photo": "Google Fotos",
    "gallery": "Galería",
    "my-photos": "Tus fotos",
    "upload-from": "Subir desde",
    "upload-or-drag": "Sube tus fotos o arrástralas a esta zona.",
    "other-choises": "O sube desde",
    "long-press-zoom": "Mantén presionadas las fotos para hacer zoom",
    "subtitle-mobile": "O subir desde",
    "add": "Añadir fotos",
    "smartphone": "Móvil",
    "family-friends": "Familia y amigos",
    "or-other-choises": "O sube desde",
    "upload-error-title": "No se pudieron subir uno o más archivos",
    "upload-error-description": "Podría estar dañado o tener un formato no compatible. Por favor, compruébalo e inténtalo de nuevo.",
    "upload-error-description-list": "Los siguientes archivos podrían estar dañados o en un formato no compatible:",
    "show-error-list": "Mostrar lista completa",
    "upload-error-description-head": "Los siguientes archivos: ",
    "upload-error-description-tail-counter": " y otros {{counter_file}} pueden estar dañados o en un formato no compatible.",
    "upload-error-description-tail": " es posible que estén dañados o en un formato no compatible.",
    "upload-computer-title": "Sube tus fotos",
    "upload-computer-description": "o arrástralas a esta zona",
    "upload-from-other-source": "O súbelas desde",
    "upload-from-computer": "Elegir fotos",
    "upload-format": "Formatos",
    "loading-wait": "Por favor espere unos momentos",
    "loading-login-google": "Estamos conectando tu cuenta de Google",
    "qr-code": "Listo para recibir fotos",
    "upload-qr-title": "Continua en tu móvil",
    "upload-qr-description": "Escanea este código con el móvil y sigue las instrucciones",
    "upload-qr-loading-title": "Sube desde tu Smartphone",
    "upload-qr-loading-description": "Por favor espere un momento, estamos generando un código QR",
    "upload-family-title": "Familia y amigos",
    "upload-family-description": "Copia este enlace y envíaselo a tus amigos y familiares.",
    "upload-family-loading-description": "Por favor espere un momento, estamos generando un enlace",
    "retry": "Sube más fotos",
    "upload-gallery-title": "Sube desde la galería de tu teléfono inteligente",
    "upload-style": "Estilo",
    "choose-with-minimum": "Elige al menos {{photos}} fotos",
    "upload-from-your-source": "Mientras esperas, puedes subir tus fotos desde",
    "hide-error-list": "Cerrar lista completa",
    "view-uploaded-photo": "Ver fotos subidas",
    "title-choose": "Elige tus fotos",
    "choose-max": "Elige {{photos}} fotos",
    "error": {
      "corrupted-files": {
        "title": "No se han podido subir algunas fotos",
        "description": "Los siguientes archivos podrían estar dañados o en un formato no compatible:",
        "cta": "Vale, gracias"
      },
      "low-memory": {
        "title": "",
        "description": "",
        "cta": "Vale, gracias"
      },
      "network-unavailable": {
        "title": "Error al subir las fotos",
        "description": "Comprueba tu conexión e inténtalo de nuevo. Si el problema persiste, vuelve a cargar la página en unos minutos.",
        "cta": "Reintentar"
      },
      "unknown": {
        "title": "Error al subir las fotos",
        "description": "Algo ha salido mal y no se han podido cargar las fotos que te han enviado. Vuelve a intentarlo.",
        "cta": "Vale, gracias"
      }
    }
  },
  "customize": {
    "other_options": "Otras opciones",
    "add-to-cart": "Añadir al carrito",
    "redo": "Repetir",
    "undo": "Cancelar",
    "add-project-title": "Añadir título al proyecto",
    "add-frame": "Añadir otro",
    "delete-frame": "Eliminar",
    "tutorial": "Tutorial",
    "save": "Guardar",
    "no-frame": "Empieza a crear",
    "no-frame-description": "Sube tus fotos o arrástralas a esta zona. A cada foto le corresponderá un solo producto.",
    "choose": "Añadir fotos",
    "create-something-else": "¿Buscas otra idea?",
    "create-new-project": "Crear un nuevo proyecto",
    "you-want-delete-frame": "¿Quieres eliminarlo?",
    "you-want-delete-frame-description": "Ya no será posible recuperar el proyecto y tendrás que hacerlo todo de nuevo.",
    "delete": "Eliminar",
    "abort": "Cancelar",
    "other-options": "Otras opciones",
    "default-project-title": "Tu producto",
    "go-to-site": "Volver al sitio",
    "ignore": "Ignorar",
    "suboptimal-quality": "La calidad de la foto no es óptima",
    "suboptimal-solution": "Puedes solucionarlo de varias maneras:",
    "change-photo": "Sustituye la foto por una de mayor calidad",
    "remove-zoom": "Elimina la ampliación que has aplicado",
    "change-format": "Elige un cuadro de menor tamaño",
    "keep-anyway": "Imprimir de todos modos",
    "continue": "Continuar",
    "no-frame-mobile": "Empieza a crear",
    "no-frame-description-mobile": "A cada foto le corresponderá un solo producto.",
    "see-other-products": "Ver otros productos",
    "confirm": "Confirmar",
    "applyAll": "Aplicar a todos ({{price}}€)",
    "open_menu": "Abrir menú",
    "color-correction": "Ideal para mejorar los colores de tus fotos, si todavía no han sido retocadas.",
    "change": "Cambiar",
    "add-another-frame": "Añade otro",
    "no-frame-description-new": "Sube tus fotos o arrástralas a esta zona.",
    "empty-state-title": "¿No ves tus fotos?",
    "empty-state-description": "Recibirás una notificación en cuanto las hayamos subido y las encontrarás en la sección:",
    "empty-state-other-photos": "O sube más fotos",
    "empty-state-cta-second": "Añadir fotos",
    "empty-state-description-mobile": "Las fotos subidas aparecerán aquí",
    "switch-to-set-3x": "Pásate al set de 3 Cuadritos",
    "switch-to-set-6x": "Pásate al set de 6 Cuadritos",
    "switch-to-set-9x": "Pásate al set de 9 Cuadritos"
  },
  "lookups": {
    "layout": "Diseño",
    "glass": "Cristal acrílico",
    "format": "Tamaño",
    "frame-color": "Color del marco",
    "passepartout-color": "Paspartú",
    "passepartout-type": "Espacio para foto",
    "correction": "Corrección de color",
    "front-surface": "Cristal acrílico",
    "passepartout": "Borde",
    "front-surface-description": "El cristal acrílico protege y aporta luminosidad a las fotos impresas en papel fotográfico mate.",
    "passepartout-description": "Puedes aplicar un borde blanco alrededor de la foto para hacer que resalte aún más.",
    "correction-description": "Te recomendamos que la apliques si no has retocado tus fotos ni aplicado filtros.",
    "suboptimal": "No es óptimo",
    "side-color": "Color del borde",
    "side-thickness": "Grosor",
    "border-type": "Borde",
    "border-type-description": "Elige el efecto que prefieras para el borde de tu lienzo y coloca en el centro los detalles importantes de la foto.",
    "paper": "Acabado",
    "format-group-print_classic": "Clásicos",
    "format-group-print_classic-referencing-poster": "Pósteres y ampliaciones",
    "format-group-poster": "Pósteres y ampliaciones",
    "format-group-poster-referencing-print_classic": "Clásicos",
    "format-defaultGroup": "",
    "format-referencingOtherGroup": "",
    "paper_color": "Color",
    "text": "Texto",
    "format-group-print_pro": "Revelados Pro",
    "format-group-print_pro-referencing-poster_pro": "Pósteres y ampliaciones Pro",
    "format-group-poster_pro": "Pósteres y ampliaciones Pro",
    "format-group-poster_pro-referencing-print_pro": "Revelados Pro",
    "boxstyle": "Estilo",
    "printtype": "Papel",
    "kit-type": "Cantidad"
  },
  "filters": {
    "blackandwhite": "Blanco y negro",
    "sepia": "Sepia",
    "crossprocess": "Cross Process",
    "route66": "Route 66",
    "vintage70": "Vintage",
    "softportrait": "Soft Portrait",
    "landscape": "Landscape",
    "drama": "Drama",
    "original": "Original",
    "mix": "Mezcla"
  },
  "edit": {
    "frame": "Encuadrar",
    "filters": "Filtros",
    "replace": "Reemplazar foto",
    "redo": "Repetir",
    "undo": "Cancelar",
    "back": "Guardar y volver",
    "save": "Guardar",
    "edit_photo": "Editar foto",
    "edit-photo": "Editar foto",
    "saving": "Guardando",
    "saved": "Cambios guardados",
    "saving_mobile": "Guardando",
    "saving-mobile": "Guardando",
    "add-photos": "Añadir fotos",
    "restore": "Rehacer",
    "borders": "Bordes",
    "adjustments": "Ajustes",
    "replace-mobile": "Reemplazar",
    "orientation": "Orientación",
    "exit": "Cerrar cambios",
    "save-modify": "Guardar cambios",
    "title": "Editar",
    "flip-vertical": "Espejo vertical",
    "flip-horizontal": "Espejo horizontal",
    "saved_mobile": "Guardado",
    "photo-next": "Foto siguiente",
    "photo-prev": "Foto anterior",
    "photo-item": ""
  },
  "modal-exit-project": {
    "title": "¿Quieres salir del proyecto?",
    "description": "Inicia sesión o regístrate para guardar el proyecto, de lo contrario se perderá.",
    "cancel": "Cancelar",
    "exit": "Salir",
    "title-with-logged-user": "¿Quieres salir del proyecto?",
    "description-with-logged-user": "Gracias al guardado automático, podrás recuperar tu trabajo desde la sección «Proyectos guardados».",
    "cancel-with-logged-user": "Cancelar",
    "exit-with-logged-user": "Guardar y salir"
  },
  "modal-quality-alert": {
    "suboptimal-quality": "La calidad de la foto\nno es óptima",
    "suboptimal-solution": "Puedes solucionarlo de varias maneras:",
    "change-photo": "Sustituye la foto por una de mayor calidad",
    "remove-zoom": "Elimina el nivel de ampliación que aplicaste a la foto.",
    "change-format": "Elige otro formato",
    "close": "Imprimir de todos modos",
    "change-format-or-photo": "Te recomendamos sustituirla por una foto de mayor calidad o elegir un tamaño más pequeño",
    "change-only-photo": "Te recomendamos sustituirla por una foto de mayor calidad",
    "suboptimal-quality-multiplr": "",
    "change-photo-clickable": "Reemplazar la foto",
    "remove-zoom-clickable": "Eliminar la ampliación",
    "change-format-clickable": "Elegir un tamaño menor",
    "sub-quality-multiple-description": "Puede que la foto salga borrosa, pero si es especial para ti, ¡imprímela igualmente!",
    "continue": "Continuar",
    "abort": "Cancelar",
    "suboptimal-quality-multiple": "La calidad de algunas fotos no es óptima",
    "fix": "Resolver",
    "ignore": "Ignorar",
    "quality-check": "Comprueba la calidad",
    "change-format-less-than": "Elige otro formato inferior a {{format}} cm",
    "delete": "Eliminar este elemento",
    "sub-quality-multiple-subdescription": "¡Lo que importa es el recuerdo!",
    "print-anyway": "Imprimir de todos modos"
  },
  "modal-empty-images": {
    "title": "Faltan fotos\nen tu proyecto",
    "description": "Para continuar, comprueba los\nespacios vacíos y sube las fotos",
    "check": "Comprobar",
    "title-adhesive": "Hay cuadros sin foto",
    "description-adhesive": "Añade las fotos que faltan para completar el set. Este producto solo está disponible en sets de 3, 6 o 9 piezas.",
    "check-adhesive": "Completa el set"
  },
  "modal-multiple-purchase": {
    "title": "¡Crea paredes chulísimas!",
    "description": "Elige las fotos según el número de cuadros que quieras crear: ¡cuantos más cuadros pidas, menos te gastas!",
    "option-3-5": "Añade entre 3 y 5 cuadros",
    "option-6-8": "Añade entre 6 y 8 cuadros",
    "option-9-more": "Añade más de 9 cuadros",
    "option-1-2": "Añade 1 o 2 cuadros"
  },
  "general": {
    "frame": "cuadro",
    "frames": "cuadros",
    "save": "Guardar",
    "chat": "Chat",
    "product": "producto",
    "products": "productos",
    "modal": "modal",
    "editor": "Editor PhotoSì",
    "set-of-frames": "Set de {{count}} Cuadrito",
    "set-of-frames_plural": "Set de {{count}} Cuadritos",
    "frame-counter": "Marco",
    "frame-counter_plural": "Marcos",
    "set-of-frames-counter": "Cuadrito",
    "set-of-frames-counter_plural": "Cuadritos",
    "photo": "foto",
    "products-counter": "{{count}} producto",
    "products-counter_plural": "{{count}} productos",
    "drag": "Sube tus fotos aquí para añadirlas al proyecto"
  },
  "modal-upload-to-cart": {
    "title": "Estamos subiendo tus fotos",
    "description": "No cierres la página, solo tardará unos instantes",
    "abort": "Cancelar",
    "title-complete": "¡Carga completada!",
    "description-complete": "Tus productos están en el carrito",
    "eta-minutes-seconds": "Solo faltan {{minutes}} y {{seconds}}",
    "eta-minutes": "Solo falta {{minutes}}",
    "eta-minutes_plural": "Solo faltan {{minutes}}",
    "eta-seconds": "Ya casi está, solo faltan {{seconds}}",
    "minutes": "{{count}} minuto",
    "minutes_plural": "{{count}} minutos",
    "seconds": "{{count}} segundos",
    "title-mobile": "Estamos subiendo\ntus fotos",
    "description-mobile": "No cierres la página, solo tardará unos instantes",
    "description-bad-network": "La conexión va un poco lenta y tardaremos más de lo previsto. Quédate en esta pantalla  para no interrumpir la subida.",
    "description-slow-network": "Tardaremos más de lo previsto, pero vamos por buen camino. Quédate en esta pantalla para no interrumpir la subida."
  },
  "modal-error-cart": {
    "title": "Error al subir las fotos",
    "description": "Puede que haya problemas de conexión. Comprueba tu red e inténtalo de nuevo.",
    "retry": "Reintentar",
    "title-mobile": "Error al subir las fotos",
    "description-mobile": "Puede que haya problemas de conexión. Comprueba tu red e inténtalo de nuevo."
  },
  "rotate_to_portrait": {
    "message": "Gira el dispositivo verticalmente para continuar"
  },
  "modal-save-changes": {
    "title": "¿Quieres guardar los cambios?",
    "description": "Tienes cambios sin guardar, si vuelves atrás los perderás.",
    "save": "Guardar",
    "saving": "Guardando...",
    "discard": "Cancelar"
  },
  "modal-apply-all": {
    "title": "¿Quieres aplicar el cambio a todas las Decoraciones de pared?",
    "abort": "Cancelar",
    "confirm": "Aplicar"
  },
  "loading": {
    "0": "",
    "1": "Danos un segundo...",
    "2": "La carga está tardando algo más de lo previsto, perdona la espera..."
  },
  "toast": {
    "fix": "Resolver",
    "suboptimal-quality": "La calidad de la foto no es óptima",
    "uploading-photo-error": "Error al cargar la foto",
    "uploading-photos-error": "Error al cargar las fotos",
    "frame-deleted-successfully": "Tu cuadro ha sido eliminado correctamente",
    "invalid-photo-format": "El formato elegido no es compatible",
    "invalid-of-some-photos-format": "El formato elegido para algunas fotos no es compatible",
    "valid-photo-format-reminder": "Recuerda seleccionar sólo archivos con formato PNG, JPG, JPEG y HEIC",
    "incognito-hint": "En el modo incógnito, algunas funciones del editor podrían no estar disponibles.",
    "accept-and-close": "Cerrar",
    "product-deleted-successfully": "Producto eliminado con éxito",
    "check": "Revisar",
    "cuts-check-hint": "Algunas fotos han sido recortadas, revisa el encuadre",
    "product-option-applied-successfully": "La opción {{option}} ha sido aplicada con éxito",
    "products-deleted-successfully": "Productos eliminados con éxito",
    "loading": "",
    "min-product-missing": "Este producto requiere un mínimo de {{min_value}} fotos.",
    "add-missing": "Añadir",
    "accept": "Entiendo",
    "project-not-uploaded": "Algunas fotos no se cargaron y se eliminaron.  Por favor, vuelve a intentarlo.",
    "min-product-missing_happy_case_classic": "Esta caja requiere un mínimo de {{min_value}} fotos.",
    "min-product-missing_happy_case_vintage": "Esta caja requiere un mínimo de {{min_value}} fotos.",
    "min-product-missing_fotokit_homedecor": "Este FotoKit requiere un mínimo de {{min_value}} fotos.",
    "min-product-missing_fotokit_miniscrap": "Este FotoKit requiere un mínimo de {{min_value}} fotos.",
    "complete-missing_happy_case_classic": "¡Esta caja está completa! Puedes añadirla al carrito cuando quieras.",
    "complete-missing_happy_case_vintage": "¡Esta caja está completa! Puedes añadirla al carrito cuando quieras.",
    "complete-missing_fotokit_homedecor": "¡Este FotoKit está completo! Puedes añadirlo al carrito cuando quieras.",
    "complete-missing_fotokit_miniscrap": "¡Este FotoKit está completo! Puedes añadirlo al carrito cuando quieras.",
    "created_newbox_happy_case_classic": "¡Esta caja está completa! Hemos pasado las demás fotos a una nueva caja.",
    "created_newbox_happy_case_vintage": "¡Esta caja está completa! Hemos pasado las demás fotos a una nueva caja.",
    "created_newbox_fotokit_homedecor": "¡Este FotoKit está completo! Hemos pasado las demás fotos a un nuevo FotoKit.",
    "created_newbox_fotokit_miniscrap": "¡Este FotoKit está completo! Hemos pasado las demás fotos a un nuevo FotoKit.",
    "show": "Echa un vistazo",
    "photos-added": "Fotos añadidas a la sección \"Tus fotos\"",
    "products-added": "{{count}} foto añadida correctamente",
    "products-added_plural": "{{count}} fotos añadidas correctamente",
    "duplicate": "Producto duplicado correctamente",
    "duplicate_plural": "Productos duplicados correctamente",
    "products-removed": "Foto eliminada con éxito",
    "products-removed_plural": "{{count}} fotos eliminadas con éxito",
    "products-restored": "Foto restaurada con éxito",
    "products-restored_plural": "{{count}} fotos restauradas con éxito",
    "product-option-updated": "Opción {{option}} actualizada",
    "product-replaced": "Foto reemplazada correctamente"
  },
  "modal-picker-google-photo": {
    "title-upload": "Subir desde Google Fotos",
    "description-upload": "Accede y elige tus fotos favoritas",
    "title-logged": "¡Tu cuenta está conectada a Google Fotos!",
    "description-logged": "Para proteger tu privacidad, Google permite que PhotoSì acceda solo a las fotos que tú elijas.",
    "choose-photo": "Elegir fotos",
    "login": "Conectarse a Google Fotos",
    "logged-with": "Conectado con",
    "logout": "Desconectar",
    "errors": {
      "no-access": "No podemos acceder a tus fotos.\nPara permitir el acceso, cierra sesión y vuelve a conectarte a Google Fotos."
    }
  },
  "chat": {
    "initialMessage": "¡Hola! Soy Sara, la asistente virtual con IA de PhotoSì. Si buscas un regalo, un producto o necesitas ayuda, ¡estoy aquí para ayudarte!",
    "title": "PhotoSì",
    "subtitle": "",
    "footer": "",
    "inputPlaceholder": "Escribe tu pregunta aquí..."
  },
  "borders": {
    "mirrored": "Reflejado",
    "extended": "Estirado",
    "folded": "Doblado"
  },
  "canvas": {
    "border-text-top": "Borde superior",
    "border-text-right": "Borde derecho",
    "border-text-bottom": "Borde inferior",
    "border-text-left": "Borde izquierdo"
  },
  "adjustments": {
    "brightness": "Brillo",
    "contrast": "Contraste",
    "saturation": "Saturación",
    "restore": "Restablecer",
    "close": "Hecho"
  },
  "lookups-options": {
    "Folded": "Doblado",
    "Mirrored": "Reflejado",
    "Extended": "Estirado",
    "homedecor": {
      "format-24x32": "24x32 cm",
      "format-32x24": "32x24 cm",
      "format-30x40": "30x40 cm",
      "format-40x30": "40x30 cm",
      "format-40x60": "40x60 cm",
      "format-60x40": "60x40 cm",
      "format-50x70": "50x70 cm",
      "format-70x50": "70x50 cm",
      "format-16x16": "16x16 cm",
      "format-18x24": "18x24 cm",
      "format-24x18": "24x18 cm",
      "format-24x24": "24x24 cm",
      "format-30x30": "30x30 cm",
      "format-40x40": "40x40 cm",
      "format-50x50": "50x50 cm",
      "format-70x70": "70x70 cm",
      "format-70x100": "70x100 cm",
      "format-100x70": "100x70 cm",
      "format-20x20": "20x20 cm",
      "format-20x30": "20x30 cm",
      "format-30x20": "30x20 cm",
      "format-12x12": "12x12 cm",
      "format-12x18": "12x18 cm",
      "format-18x12": "18x12 cm",
      "format-15x15": "15x15 cm",
      "format-15x20": "15x20 cm",
      "format-20x15": "20x15 cm",
      "format-17x17": "17x17 cm",
      "format-50x100": "50x100 cm",
      "format-100x50": "100x50 cm",
      "format-60x90": "60x90 cm",
      "format-90x60": "90x60 cm",
      "format-90x90": "90x90 cm",
      "format-90x120": "90x120 cm",
      "format-120x90": "120x90 cm",
      "format-120x120": "120x120 cm",
      "format-13x18": "13x18 cm",
      "format-18x13": "18x13 cm",
      "format-60x60": "60x60 cm",
      "format-100x100": "100x100 cm",
      "frame-color-BLACK": "Negro",
      "frame-color-WHITE": "Blanco",
      "frame-color-WOOD": "Madera",
      "frame-color-SILVER": "Plata",
      "frame-color-GOLD": "Oro",
      "frame-color-BRONZE": "Bronce",
      "passepartout-color-WHITE": "Blanco",
      "passepartout-color-BLACK": "Negro",
      "passepartout-type-PHYSICAL_STANDARD": "Clásico",
      "passepartout-type-PHYSICAL_DECENTERED": "Descentrado",
      "correction-YES": "Sí",
      "correction-NO": "No",
      "passepartout-NO": "sin frontera",
      "passepartout-YES": "con borde",
      "layout-1x": "1x",
      "layout-4x": "4x",
      "layout-6x": "6x",
      "layout-9x": "9x",
      "layout-1x_FULL_PHOTO": "foto completa",
      "front-surface-NO": "No",
      "front-surface-YES": "Sí",
      "side-color-WHITE": "Blanco",
      "side-color-BLACK": "Negro",
      "side-thickness-2_CM": "2 cm",
      "side-thickness-4_CM": "3,5 cm",
      "border-type-Folded": "Doblado",
      "border-type-Mirrored": "Reflejado",
      "border-type-Extended": "Estirado",
      "kit-type-3x": "Set de 3 piezas",
      "kit-type-6x": "Set de 6 piezas",
      "kit-type-9x": "Set de 9 piezas",
      "kit-type-3x_selected-lookup": "Set de 3 uds.",
      "kit-type-6x_selected-lookup": "Set de 6 uds.",
      "kit-type-9x_selected-lookup": "Set de 9 uds."
    },
    "print": {
      "format-7x10": "7x10 cm",
      "format-10x10": "10x10 cm",
      "format-10x13": "10x13 cm",
      "format-10x15": "10x15 cm",
      "format-10x_PANORAMIC": "10 cm variable",
      "format-12x16": "12x16 cm",
      "format-12x_PANORAMIC": "12 cm variable",
      "format-13x13": "13x13 cm",
      "format-13x17.33": "13x17 cm",
      "format-13x19.5": "13x19 cm",
      "format-13x_PANORAMIC": "13 cm variable",
      "format-15x22": "15x22 cm",
      "format-20x27": "20x27 cm",
      "format-30x45": "30x45 cm",
      "format-40x50": "40x50 cm",
      "format-50x75": "50x75 cm",
      "format-24x32": "24x32 cm",
      "format-32x24": "32x24 cm",
      "format-30x40": "30x40 cm",
      "format-40x30": "40x30 cm",
      "format-40x60": "40x60 cm",
      "format-60x40": "60x40 cm",
      "format-50x70": "50x70 cm",
      "format-70x50": "70x50 cm",
      "format-16x16": "16x16 cm",
      "format-18x24": "18x24 cm",
      "format-24x18": "24x18 cm",
      "format-24x24": "24x24 cm",
      "format-30x30": "30x30 cm",
      "format-40x40": "40x40 cm",
      "format-50x50": "50x50 cm",
      "format-50x60": "50x60 cm",
      "format-70x70": "70x70 cm",
      "format-70x100": "70x100 cm",
      "format-100x70": "100x70 cm",
      "format-20x20": "20x20 cm",
      "format-20x30": "20x30 cm",
      "format-30x20": "30x20 cm",
      "format-12x12": "12x12 cm",
      "format-12x18": "12x18 cm",
      "format-18x12": "18x12 cm",
      "format-15x15": "15x15 cm",
      "format-15x20": "15x20 cm",
      "format-20x15": "20x15 cm",
      "format-17x17": "17x17 cm",
      "format-50x100": "50x100 cm",
      "format-100x50": "100x50 cm",
      "format-60x90": "60x90 cm",
      "format-90x60": "90x60 cm",
      "format-90x90": "90x90 cm",
      "format-90x120": "90x120 cm",
      "format-120x90": "120x90 cm",
      "format-120x120": "120x120 cm",
      "format-13x18": "13x18 cm",
      "format-18x13": "18x13 cm",
      "format-60x60": "60x60 cm",
      "format-100x100": "100x100 cm",
      "frame-color-BLACK": "Negro",
      "frame-color-WHITE": "Blanco",
      "frame-color-WOOD": "Madera",
      "frame-color-SILVER": "Plata",
      "frame-color-GOLD": "Oro",
      "frame-color-BRONZE": "Bronce",
      "passepartout-color-WHITE": "Blanco",
      "passepartout-color-BLACK": "Negro",
      "passepartout-type-PHYSICAL_STANDARD": "Clásico",
      "passepartout-type-PHYSICAL_DECENTERED": "Descentrado",
      "correction-YES": "Sí",
      "correction-YES-description": "Ideal para mejorar los colores de tus fotos, si todavía no han sido retocadas.",
      "correction-NO": "No",
      "correction-NO-description": "",
      "passepartout-NO": "No",
      "passepartout-YES": "Sí",
      "layout-1x": "1x",
      "layout-4x": "4x",
      "layout-6x": "6x",
      "layout-9x": "9x",
      "layout-1x_FULL_PHOTO": "foto completa",
      "front-surface-NO": "No",
      "front-surface-YES": "Sí",
      "side-color-WHITE": "Blanco",
      "side-color-BLACK": "Negro",
      "side-thickness-2_CM": "2 cm",
      "side-thickness-4_CM": "3,5 cm",
      "border-type-Folded": "Doblado",
      "border-type-Mirrored": "Reflejado",
      "border-type-Extended": "Estirado",
      "paper-GLOSSY": "Brillante",
      "paper-GLOSSY-description": "Una explosión de luz para tus fotos más vibrantes",
      "paper-MATTE": "Mate",
      "paper-MATTE-description": "Acabado aterciopelado y elegante, sin reflejos",
      "format-15x22.5": "15x22 cm",
      "format-variable": " cm",
      "format-8x10": "8x10 cm",
      "format-12x15": "12x15 cm",
      "format-20x25": "20x25 cm",
      "format-10x00": "10 cm variable",
      "format-12x00": "12 cm variable",
      "format-13x00": "13 cm variable",
      "format-13x19": "13x19 cm",
      "format-24x30": "24x30 cm",
      "format-24x36": "24x36 cm",
      "format-30x60": "30x60 cm",
      "format-35x35": "35x35 cm",
      "format-35x50": "35x50 cm",
      "format-60x80": "60x80 cm",
      "boxstyle-JUNGLE": "Jungle",
      "boxstyle-LOVE_IS": "Love is",
      "boxstyle-BLOOM": "Bloom",
      "boxstyle-OCEAN": "Ocean",
      "boxstyle-MOON": "Moon",
      "boxstyle-SUNSHINE": "Sunshine",
      "boxstyle-LIFE": "Life",
      "boxstyle-JUNGLE-description": "",
      "boxstyle-LOVE_IS-description": "",
      "boxstyle-BLOOM-description": "",
      "boxstyle-OCEAN-description": "",
      "boxstyle-MOON-description": "",
      "boxstyle-SUNSHINE-description": "",
      "boxstyle-LIFE-description": "",
      "boxstyle-CHRISTMAS": "Magic Christmas",
      "boxstyle-FLOWER": "Flower",
      "boxstyle-GAME": "Game",
      "boxstyle-GREEN": "Green",
      "boxstyle-WONDER": "Wonder",
      "boxstyle-CHRISTMAS-description": "",
      "boxstyle-FLOWER-description": "",
      "boxstyle-GAME-description": "",
      "boxstyle-GREEN-description": "",
      "boxstyle-WONDER-description": "",
      "format-10x13.33": "10x13 cm",
      "printtype-PHOTOGRAPHIC": "Papel fotográfico Fujifilm",
      "printtype-PHOTOGRAPHIC-active-label": "Fujifilm",
      "printtype-PHOTOGRAPHIC-description": "• Para amantes del papel tradicional \n• Ideal para fotografías profesionales",
      "printtype-INKJET": "Papel fotográfico PhotoSì",
      "printtype-INKJET-active-label": "PhotoSì",
      "printtype-INKJET-description": "• Excelente reproducción del color\n• Opción ecosostenible",
      "boxstyle-LOVE_IS_SPECIAL": "Love you",
      "boxstyle-LOVE_IS_SPECIAL-description": ""
    },
    "kit-type": {
      "3x": "juego de 3 piezas",
      "6x": "juego de 6 piezas",
      "9x": "juego de 9 piezas"
    }
  },
  "modal-privacy-policy": {
    "privacy-policy-info": "Política de privacidad",
    "editor-privacy-policy-info": "Información sobre el uso del editor",
    "main-content": "Cuando utilizas nuestro editor de fotos, empleamos una tecnología de tu navegador llamada OPFS – Origin Private File System. Este sistema nos permite gestionar de forma más rápida y segura los archivos que estás editando, directamente desde tu dispositivo.",
    "paragraph-1-title": "¿Qué significa esto para ti?",
    "paragraph-1-content-1": "Todo el trabajo que haces permanece privado y seguro, dentro de tu navegador.",
    "paragraph-1-content-2": "Tus archivos NO se envían a nuestros servidores mientras los estás editando.",
    "paragraph-2-title": "¿Cómo protegemos tu privacidad?",
    "paragraph-2-content-1": "No se comparte ni se rastrea ningún dato a través de OPFS.",
    "paragraph-2-content-2": "No tenemos acceso a tus archivos guardados localmente.",
    "paragraph-2-content-3": "Solo tú puedes acceder a los datos y únicamente desde el mismo navegador y dispositivo.",
    "know-more-1": "¿Quieres saber más? Consulta nuestra",
    "privacy-policy": "Política de privacidad",
    "know-more-2": "al completo para obtener todos los detalles sobre cómo tratamos tus datos y cuáles son tus derechos.",
    "thanks": "Gracias por confiar en nosotros. ¡Esperamos que disfrutes creando con nuestro editor!"
  },
  "header": {
    "photo": "Tus fotos",
    "save": "Guardar",
    "saved": "¡Guardado!",
    "total": "Total",
    "products": "productos",
    "go-to-cart": "Añadir al carrito",
    "confirm": "Confirmar",
    "product": "producto",
    "product_plural": "productos",
    "articles": "artículos:",
    "add-project-title": "Agregar título al proyecto",
    "save-project-title": "Guardar título del proyecto",
    "edit-project-title": "Editar título del proyecto",
    "save-project": "Guardar el proyecto",
    "saving-project": "Guardando el proyecto",
    "project-saved": "Proyecto guardado",
    "uploading": "Subiendo fotos",
    "photo-notification": ""
  },
  "discounts-tooltip": {
    "prints-classic": "Revelados Clásicos",
    "prints-vintage": "Revelados Vintage",
    "prints-pro": "Revelados Clásicos Pro",
    "n-units-size": "{{quantity}} unidades ({{format}})",
    "print_classic": "Revelados Clásicos",
    "poster": "Pósteres y ampliaciones",
    "print_vintage": "Revelados Vintage",
    "happy_case_classic": "Happy Case Clásica",
    "happy_case_vintage": "Happy Case Vintage",
    "fotokit_homedecor": "FotoKit Home Decor",
    "fotokit_miniscrap": "FotoKit Mini Scrap",
    "print_classic_with_border": "Revelados con borde"
  },
  "discounts-table": {
    "prints-title": "¡Cuanto más imprimas, menos gastarás!",
    "prints-description": "Así es como se obtienen los descuentos por cantidad en los Revelados",
    "prints-from-to": "de {{from}} a {{to}} fotos",
    "prints-from-more": "desde {{from}} y más",
    "price-discount": "desde {{price}} €",
    "unit-discount": "c\/u",
    "prints-to-reach": "Añade {{photos}} fotos más para un {{discount}} % de descuento",
    "greetings": "¡Felicidades!",
    "photo": "{{photos}} fotos",
    "prints-subtitle": "Aquí te explicamos cómo obtener descuentos por cantidad en impresiones.",
    "discover-discount": "Descubres",
    "prints-to-reach-head": "Añade ",
    "prints-to-reach-middle": "{{count}} foto más",
    "prints-to-reach-middle_plural": "{{count}} fotos más",
    "prints-to-reach-tail": " para un {{discount}} de descuento",
    "prints-description-mobile": "Descuentos para el formato elegido: {{format}}"
  },
  "modal-suggested-format": {
    "title": "Tamaño recomendado",
    "option-1": "10x10 cm",
    "description-1": "Cuadrado",
    "option-2": "10x13 cm",
    "description-2": "Ideal para evitar recortes en tus fotos",
    "option-3": "10x15 cm",
    "description-3": "Estándar para marcos y álbumes con fundas",
    "option-4": "10 cm variable",
    "description-4": "Mantiene las proporciones originales. Cada foto puede tener un tamaño diferente.",
    "continue": "Continuar",
    "suggested": "Recomendado"
  },
  "actions": {
    "add_x": "Añadir {{x}}",
    "remove_x": "Eliminar {{x}}",
    "edit_x": "Editar {{x}}",
    "close_x": "Cerrar {{x}}",
    "open_x": "Abrir {{x}}",
    "rotate_left": "Girar a la izquierda",
    "rotate_right": "Girar a la derecha",
    "increase_zoom": "Zoom +",
    "reduce_zoom": "Zoom -",
    "drag_or_edit": "Arrastrar o editar",
    "slide_right": "Arrastrar a la derecha",
    "slide_left": "Arrastrar a la izquierda",
    "select_x": "Seleccionar {{x}}",
    "edit": "Editar",
    "duplicate": "Duplicar",
    "save_and_return": "Guardar y volver",
    "action-list": "Comportamiento",
    "delete": "Eliminar",
    "replica": "Copias",
    "add_border": "Agregar un borde",
    "zoom": "Vista previa",
    "options": "Opciones",
    "select": "Seleccionar",
    "quality": "Mala calidad",
    "increase": "Agregar",
    "decrease": "Disminuir",
    "format": "Formato",
    "finishing": "Refinamiento",
    "quantity": "Cantidad",
    "save": "Guardar cambios",
    "quit_without_save": "Salir sin guardar",
    "resolve-quality": "Solucionar calidad",
    "sub-quality": "Calidad no óptima",
    "paper": "Acabado del papel",
    "change-format": "Cambiar tamaño",
    "print-options": "Ver opciones de impresión",
    "choose-format": "Elige el tamaño",
    "save_and_close": "Guardar y cerrar",
    "close": "Cerrar",
    "select_photo": "Seleccionar foto número {{number}}, {{count}} copia",
    "select_photo_plural": "Seleccionar foto número {{number}}, {{count}} copias",
    "deselect_photo": "Deseleccionar foto número {{number}}, {{count}} copia",
    "deselect_photo_plural": "Deseleccionar foto número {{number}}, {{count}} copias"
  },
  "photo-drawer": {
    "my-photos": "Tus fotos",
    "your-photos": "Tus fotos",
    "order-by": "Ordenar por",
    "upload": "Subir fotos",
    "upload-more": "Sube más fotos",
    "upload-from-gallery": "Subir desde la galería",
    "add-n-photos": "Añade {{number}} fotos al proyecto",
    "select-to-add": "Selecciona las fotos para añadirlas",
    "shot-date": "Fecha de captura",
    "upload-date": "Fecha de subida",
    "adding": "Añadiendo...",
    "photos-added-to-project": "¡Fotos añadidas al proyecto!",
    "select-photo": "Seleccionar foto",
    "name": "Nombre del archivo",
    "shot-date-most-recent": "Fecha de captura: más reciente",
    "shot-date-less-recent": "Fecha de captura: menos reciente",
    "upload-date-most-recent": "Fecha de subida: más reciente",
    "upload-date-less-recent": "Fecha de subida: menos reciente",
    "name-alphabetic": "Nombre del archivo: A-Z",
    "name-alphabetic-reverse": "Nombre del archivo: Z-A",
    "upload-from": "Subir desde",
    "waiting-upload": "Por favor espere a que se carguen las fotos...",
    "empty-text": "Aquí encontrarás tus fotos una \nvez cargadas",
    "add-photos": "Añade fotos al proyecto"
  },
  "modal-picker-my-photos": {
    "title": "Tus fotos",
    "deselect-all": "Deseleccionar todo",
    "confirm": "Confirmar",
    "more-print-less-price": "¡Cuanto más imprimas, menos gastarás!",
    "add-n-photos-to-x-discount": "Con {{n}} copias consigues un {{x}} de descuento",
    "select-all": "Seleccionar todo",
    "progress": "Subiendo tus fotos...",
    "completed": "Listo",
    "delete-selected": "Eliminar",
    "loading": "Cargando...",
    "waiting": "Por favor espere unos momentos...",
    "continue": "Continuar",
    "black": "Marco negro",
    "white": "Marco blanco",
    "3x": "Set de 3 Cuadritos",
    "6x": "Set de 6 Cuadritos",
    "9x": "Set de 9 Cuadritos",
    "3x_mobile": "3 Cuadritos",
    "6x_mobile": "6 Cuadritos",
    "9x_mobile": "9 Cuadritos",
    "options-title": "Selecciona el set",
    "options-title-mobile": "Color y cantidad",
    "options-header-title-mobile": "Set de Cuadritos"
  },
  "add-other-products": {
    "add-other-products": "¿Quieres añadir algo?",
    "prints-classic": "Revelados Clásicos",
    "prints-vintage": "Revelados Vintage",
    "prints-pro": "Revelados Clásicos Pro",
    "frame": "Cuadros con marco",
    "frame-pro": "Cuadros con marco Pro",
    "add": "Añadir",
    "from-x": "desde {{price}}"
  },
  "tooltip-save-project": {
    "title": "Título",
    "auto-saved": "¡Proyecto guardado automáticamente!",
    "last-save_date_hour": "Último guardado: {{date}} a las {{hour}}",
    "saving": "Guardando...",
    "placeholder": "Proyecto 1",
    "edit-auto-saved": "¡Guardado! Todos los cambios se guardan automáticamente"
  },
  "authentication": {
    "landing-title": "Inicia sesión o regístrate",
    "landing-subtitle": "Para guardar un proyecto, debes iniciar sesión con tu cuenta o registrarte.",
    "login-title": "¡Qué bien verte de nuevo!",
    "login-subtitle": "",
    "check-email-title": "Introduce tu correo electrónico",
    "check-email-subtitle": "",
    "forgot-password-title": "¡Tienes correo!",
    "forgot-password-subtitle": "Te hemos enviado un correo electrónico para crear una nueva contraseña. Si no lo encuentras, te sugerimos que revises también tu bandeja de correo no deseado.",
    "signup-title": "Crea tu cuenta",
    "signup-subtitle": "",
    "signup-completed-title": "¡Tu cuenta ha sido creada con éxito!",
    "signup-completed-subtitle": "",
    "signup-completed-cta-label": "Cerrar",
    "manage-consents-title": "Gestionar consentimientos",
    "manage-consents-subtitle": "",
    "vat-user-signup-completed-title": "¡Tu cuenta ha sido creada con éxito!",
    "vat-user-signup-completed-subtitle": "Puedes introducir tus datos de IVA más tarde en la sección de perfil y obtener el descuento del 40 %.",
    "vat-user-signup-completed-cta-label": "Rellenar más tarde",
    "login-page-landing-title": "Inicia sesión o regístrate",
    "login-page-landing-subtitle": "Para continuar trabajando en tu proyecto, inicia sesión con tu cuenta o registrarte."
  },
  "action-bar": {
    "all": "Todo",
    "cut": "Con recorte"
  },
  "colors": {
    "black": "Negro",
    "white": "Blanco",
    "grey": "Gris",
    "greige": "Greige",
    "hazelnut": "Nuez",
    "beige": "Beige",
    "yellow": "Amarillo",
    "cream": "Crema",
    "vanilla": "Vainilla",
    "peach": "Durazno",
    "ivory": "Marfil",
    "pink": "Rosa",
    "candy": "Caramelo",
    "peony": "Peonía",
    "fuchsia": "Fucsia",
    "red": "Rojo",
    "lavender": "Lavanda",
    "lilac": "Lila",
    "ice": "Celeste",
    "sky": "Hielo",
    "indigo": "Índigo",
    "blue": "Azul",
    "lake": "Turquesa",
    "mint": "Menta",
    "green": "Verde"
  },
  "modal-configuration-steps": {
    "band-title": "Elegir la medida",
    "format-title": "Elegir el tamaño",
    "avoid-cuts": "Cómo evitar cortes en las fotos",
    "continue": "Continuar",
    "formats-content": {
      "10x13": "Formato predeterminado de los smartphones",
      "13x19.5": "Estándar para marcos y álbumes de fotos",
      "8x10": "Pequeño tamaño, grandes emociones que guardar.",
      "15x22.5": "Estándar para marcos y álbumes de fotos",
      "20x27": "",
      "13x13": "Cuadrado",
      "20x30": "",
      "40x50": "",
      "50x50": "",
      "12x15": "El tamaño perfecto para revivir cada momento con calidez.",
      "15x15": "Cuadrado",
      "20x25": "Un recuerdo que llena el espacio e ilumina la habitación.",
      "13x17.33": "Formato predeterminado de los smartphones",
      "12x18": "Estándar para marcos y álbumes de fotos",
      "40x40": "",
      "40x60": "",
      "15x20": "Formato predeterminado de los smartphones",
      "50x70": "",
      "50x60": "",
      "12x12": "Cuadrado",
      "50x75": "",
      "10x10": "Cuadrado",
      "7x10": "Estándar para marcos y álbumes de fotos",
      "30x45": "",
      "10x15": "Estándar para marcos y álbumes de fotos",
      "12x16": "Formato predeterminado de los smartphones",
      "30x40": "",
      "20x20": "",
      "8x_PANORAMIC": "Mantiene las proporciones originales de la foto",
      "12x_PANORAMIC": "Mantiene las proporciones originales de la foto",
      "30x_PANORAMIC": "Mantiene las proporciones originales de la foto",
      "20x_PANORAMIC": "Mantiene las proporciones originales de la foto",
      "13x_PANORAMIC": "Mantiene las proporciones originales de la foto",
      "7x_PANORAMIC": "Mantiene las proporciones originales de la foto",
      "10x_PANORAMIC": "Mantiene las proporciones originales de la foto",
      "40x_PANORAMIC": "Mantiene las proporciones originales de la foto",
      "15x_PANORAMIC": "Mantiene las proporciones originales de la foto",
      "50x_PANORAMIC": "Mantiene las proporciones originales de la foto",
      "suggested": "Ideal para evitar cortes en tus fotos",
      "13x19": "Estándar para marcos y álbumes de fotos",
      "15x22": "Estándar para marcos y álbumes de fotos",
      "13x17": "Formato predeterminado de los smartphones",
      "10x00": "Mantiene las proporciones originales de la foto",
      "8x00": "Mantiene las proporciones originales de la foto",
      "12x00": "Mantiene las proporciones originales de la foto",
      "30x00": "Mantiene las proporciones originales de la foto",
      "20x00": "Mantiene las proporciones originales de la foto",
      "13x00": "Mantiene las proporciones originales de la foto",
      "7x00": "Mantiene las proporciones originales de la foto",
      "40x00": "Mantiene las proporciones originales de la foto",
      "15x00": "Mantiene las proporciones originales de la foto",
      "50x00": "Mantiene las proporciones originales de la foto",
      "18x24": "",
      "24x24": "",
      "24x30": "",
      "24x36": "",
      "30x30": "",
      "35x35": "",
      "35x50": "",
      "30x60": "",
      "60x80": "",
      "70x100": "",
      "print_classic": {
        "7x00": "Mantiene las proporciones originales de la foto",
        "7x_PANORAMIC": "Mantiene las proporciones originales de la foto",
        "10x10": "Formato cuadrado",
        "10x13": "Formato estándar de móvil",
        "10x15": "Tamaño estándar para marcos y álbumes de fotos",
        "10x_PANORAMIC": "Mantiene las proporciones originales de la foto",
        "10x00": "Mantiene las proporciones originales de la foto",
        "12x12": "Formato cuadrado",
        "12x16": "Formato estándar de móvil",
        "12x18": "Tamaño estándar para marcos y álbumes de fotos",
        "12x00": "Mantiene las proporciones originales de la foto",
        "12x_PANORAMIC": "Mantiene las proporciones originales de la foto",
        "13x13": "Formato cuadrado",
        "13x17": "Formato estándar de móvil",
        "13x17.33": "Formato estándar de móvil",
        "13x19": "Tamaño estándar para marcos y álbumes de fotos",
        "13x19.5": "Tamaño estándar para marcos y álbumes de fotos",
        "13x_PANORAMIC": "Mantiene las proporciones originales de la foto",
        "13x00": "Mantiene las proporciones originales de la foto",
        "15x15": "Formato cuadrado",
        "15x20": " ",
        "15x22.5": " ",
        "15x22": " ",
        "15x_PANORAMIC": "Mantiene las proporciones originales de la foto",
        "15x00": "Mantiene las proporciones originales de la foto",
        "7x10": "Tamaño mini, ideal para tarjetas de felicitación"
      },
      "poster": {
        "20x20": "",
        "20x27": "",
        "20x30": "",
        "30x40": "",
        "30x45": "",
        "40x40": "",
        "40x50": "",
        "40x60": "",
        "50x50": "",
        "50x70": "",
        "50x75": "",
        "50x60": ""
      },
      "print_vintage": {
        "8x10": "Pequeño tamaño, grandes emociones que guardar.",
        "12x15": "El tamaño perfecto para revivir cada momento con calidez.",
        "20x25": "Un recuerdo que llena el espacio e ilumina la habitación."
      },
      "print_pro": {
        "10x13": "Formato estándar de móvil",
        "10x15": "Tamaño estándar para marcos y álbumes de fotos",
        "12x16": "Formato estándar de móvil",
        "12x18": "Tamaño estándar para marcos y álbumes de fotos",
        "13x17.33": "Formato estándar de móvil",
        "13x17": "Formato estándar de móvil",
        "13x19": "Tamaño estándar para marcos y álbumes de fotos",
        "13x19.5": "Tamaño estándar para marcos y álbumes de fotos",
        "15x20": " ",
        "15x22.5": " ",
        "15x22": " ",
        "7x10": "Tamaño mini, ideal para tarjetas de felicitación"
      },
      "poster_pro": {
        "20x20": "",
        "18x24": "",
        "20x25": "",
        "24x24": "",
        "20x30": "",
        "24x30": "",
        "24x36": "",
        "30x30": "",
        "30x45": "",
        "30x40": "",
        "35x35": "",
        "40x40": "",
        "35x50": "",
        "30x60": "",
        "40x50": "",
        "50x50": "",
        "40x60": "",
        "50x70": "",
        "50x60": "",
        "50x75": "",
        "60x80": "",
        "70x100": ""
      },
      "happy_case_classic": {
        "one": "",
        "other": ""
      },
      "happy_case_vintage": {
        "one": "",
        "other": ""
      },
      "fotokit_homedecor": {
        "one": "",
        "other": ""
      },
      "fotokit_miniscrap": {
        "one": "",
        "other": ""
      },
      "print_classic_with_border": {
        "7x00": "Mantiene las proporciones originales de la foto",
        "7x_PANORAMIC": "Mantiene las proporciones originales de la foto",
        "10x10": "Formato cuadrado",
        "10x13": "Formato estándar de móvil",
        "10x15": "Tamaño estándar para marcos y álbumes de fotos",
        "10x_PANORAMIC": "Mantiene las proporciones originales de la foto",
        "10x00": "Mantiene las proporciones originales de la foto",
        "12x12": "Formato cuadrado",
        "12x16": "Formato estándar de móvil",
        "12x18": "Tamaño estándar para marcos y álbumes de fotos",
        "12x00": "Mantiene las proporciones originales de la foto",
        "12x_PANORAMIC": "Mantiene las proporciones originales de la foto",
        "13x13": "Formato cuadrado",
        "13x17": "Formato estándar de móvil",
        "13x17.33": "Formato estándar de móvil",
        "13x19": "Tamaño estándar para marcos y álbumes de fotos",
        "13x19.5": "Tamaño estándar para marcos y álbumes de fotos",
        "13x_PANORAMIC": "Mantiene las proporciones originales de la foto",
        "13x00": "Mantiene las proporciones originales de la foto",
        "15x15": "Formato cuadrado",
        "15x20": " ",
        "15x22.5": " ",
        "15x22": " ",
        "15x_PANORAMIC": "Mantiene las proporciones originales de la foto",
        "15x00": "Mantiene las proporciones originales de la foto",
        "7x10": "Tamaño mini, ideal para tarjetas de felicitación"
      }
    },
    "format": {
      "10x13": "10x13 cm",
      "13x19.5": "13x19 cm",
      "8x10": "8x10 cm",
      "15x22.5": "15x22 cm",
      "20x27": "20x27 cm",
      "13x13": "13x13 cm",
      "20x30": "20x30 cm",
      "40x50": "40x50 cm",
      "50x50": "50x50 cm",
      "12x15": "12x15 cm",
      "15x15": "15x15 cm",
      "20x25": "20x25 cm",
      "13x17.33": "13x17 cm",
      "12x18": "12x18 cm",
      "40x40": "40x40 cm",
      "40x60": "40x60 cm",
      "15x20": "15x20 cm",
      "50x70": "50x70 cm",
      "50x60": "50x60 cm",
      "12x12": "12x12 cm",
      "50x75": "50x75 cm",
      "10x10": "10x10 cm",
      "7x10": "7x10 cm",
      "30x45": "30x45 cm",
      "10x15": "10x15 cm",
      "12x16": "12x16 cm",
      "30x40": "30x40 cm",
      "20x20": "20x20 cm",
      "8x_PANORAMIC": "8 cm variable",
      "12x_PANORAMIC": "12 cm variable",
      "30x_PANORAMIC": "30 cm  variable",
      "20x_PANORAMIC": "20 cm variable",
      "13x_PANORAMIC": "13 cm variable",
      "7x_PANORAMIC": "7 cm variable",
      "10x_PANORAMIC": "10 cm variable",
      "40x_PANORAMIC": "40 cm variable",
      "15x_PANORAMIC": "15 cm variable",
      "50x_PANORAMIC": "50 cm variable",
      "13x19": "13x19 cm",
      "15x22": "15x22 cm",
      "13x17": "13x17 cm",
      "8x00": "8 cm variable",
      "12x00": "12 cm variable",
      "30x00": "30 cm variable",
      "20x00": "20 cm variable",
      "13x00": "13 cm variable",
      "7x00": "7 cm variable",
      "10x00": "10 cm variable",
      "40x00": "40 cm variable",
      "15x00": "15 cm variable",
      "50x00": "50 cm variable",
      "18x24": "18x24 cm",
      "24x24": "24x24 cm",
      "24x30": "24x30 cm",
      "24x36": "24x36 cm",
      "30x30": "30x30 cm",
      "35x35": "35x35 cm",
      "35x50": "35x50 cm",
      "30x60": "30x60 cm",
      "60x80": "60x80 cm",
      "70x100": "70x100 cm"
    },
    "band": {
      "7": "7 cm",
      "10": "10 cm",
      "12": "12 cm",
      "13": "13 cm",
      "15": "15 cm"
    },
    "bands-content": {
      "available-formats": "Tamaños disponibles"
    },
    "avoid-cuts-description": "El tamaño recomendado es el más indicado para las fotos que has seleccionado y así evitar recortes no deseados.\n\nSi prefieres otro tamaño, las fotos aparecerán recortadas, pero podrás seguir ajustando el encuadre en los pasos siguientes.",
    "best-seller": "Superventas",
    "suggested": "Recomendado",
    "bands-price": {
      "7": "desde 0,49 €",
      "10": "desde 0,59 €",
      "12": "desde 0,79 €",
      "13": "desde 0,99 €",
      "15": "desde 1,99 €",
      "print_classic": {
        "7": "desde 0,29 €",
        "10": "desde 0,35 €",
        "12": "desde 0.42 €",
        "13": "desde 0,48 €",
        "15": "desde 0,99 €",
        "20": "desde 1,99 €",
        "30": "desde 8,90 €"
      },
      "poster": {
        "one": "",
        "other": ""
      },
      "print_vintage": {
        "one": "",
        "other": ""
      },
      "print_pro": {
        "7": "desde 0,49 €",
        "10": "desde 0,59 €",
        "12": "desde 0,79 €",
        "13": "desde 0,99 €",
        "15": "desde 1,99 €"
      },
      "poster_pro": {
        "one": "",
        "other": ""
      },
      "happy_case_classic": {
        "one": "",
        "other": ""
      },
      "happy_case_vintage": {
        "one": "",
        "other": ""
      },
      "photo_kit": {
        "one": "",
        "other": ""
      }
    },
    "box-style-title": "Elige el estilo",
    "box-style": {
      "bloom": "Bloom",
      "christmas": "Magic Christmas",
      "love_is": "Love is",
      "moon": "Moon",
      "ocean": "Ocean",
      "sunshine": "Sunshine",
      "flower": "Flower",
      "game": "Game",
      "green": "Green",
      "life": "Life",
      "wonder": "Wonder",
      "jungle": "Jungle",
      "love_is_special": "Love you"
    },
    "box-style-price": "desde {{price}}",
    "continue-with": "Continuar con el {{format}}",
    "format-change": "Puedes cambiarlo más tarde",
    "format-adapt": "Los formatos variables mantienen la relación de aspecto original.\nCada foto puede tener un tamaño diferente",
    "papertype-title": "Elegir el papel",
    "papertype": {
      "photographic": "Papel fotográfico Fujifilm",
      "inkjet": "Papel fotográfico PhotoSì"
    },
    "papertype-content": {
      "photographic": "• Para amantes del papel tradicional\n• Ideal para fotografías profesionales",
      "inkjet": "• Excelente reproducción del color\n• Opción ecosostenible"
    },
    "printtype": {
      "photographic": "Papel fotográfico Fujifilm",
      "inkjet": "Papel fotográfico PhotoSì"
    },
    "printtype-content": {
      "photographic": "• Para amantes del papel tradicional\n• Ideal para fotografías profesionales",
      "inkjet": "• Excelente reproducción del color\n• Opción ecosostenible"
    },
    "paperfinish-title": "Elegir el acabado",
    "paperfinish": {
      "glossy": "Brillante",
      "matte": "Mate"
    },
    "paperfinish-content": {
      "glossy": "Una explosión de luz para tus fotos más vibrantes",
      "matte": "Acabado aterciopelado y elegante, sin reflejos"
    },
    "paper": {
      "glossy": "Brillante",
      "matte": "Mate"
    },
    "paper-content": {
      "glossy": "Una explosión de luz para tus fotos más vibrantes",
      "matte": "Acabado aterciopelado y elegante, sin reflejos"
    },
    "suggested-lookup": "Recomendado",
    "option-prev": "",
    "option-next": ""
  },
  "group-header": {
    "add-product": "Añadir producto",
    "add": "Añadir",
    "add-title": "¿Que deseas añadir?",
    "add-new-product": "Añadir otro producto",
    "other-product": "Otros productos",
    "other-photo": "Más fotos",
    "add-product-2": "Añadir producto",
    "add-new-product-disabled": "Subiendo fotos",
    "add-more-products": "Añadir más productos",
    "add-more-photos": "Añadir más fotos"
  },
  "group-action-bar": {
    "select": "Seleccionar",
    "deselect": "Deseleccionar",
    "selected": "{{count}} seleccionado",
    "selected_plural": "{{count}} seleccionados",
    "grid": "Vista",
    "delete-selected": "Eliminar selección"
  },
  "groups": {
    "print_classic-title": "Revelados Clásicos",
    "poster-title": "Pósteres y ampliaciones",
    "print_classic-description": "desde 0,19 € c\/u",
    "poster-description": "desde 3,99 € c\/u",
    "print_vintage-title": "Revelados Vintage",
    "print_vintage-description": "desde 0,35 € c\/u",
    "print_pro-title": "Revelados Pro",
    "poster_pro-title": "Pósteres y ampliaciones Pro",
    "happy_case_classic-title": "Happy Case Clásica",
    "happy_case_vintage-title": "Happy Case Vintage",
    "fotokit_homedecor-title": "FotoKit Home Decor",
    "fotokit_miniscrap-title": "FotoKit Mini Scrap",
    "happy_case_classic-warning": "Cada caja debe tener al menos {{photos}} fotos. Añade las que faltan.",
    "happy_case_vintage-warning": "Cada caja debe tener al menos {{photos}} fotos. Añade las que faltan.",
    "fotokit_homedecor-warning": "Cada FotoKit debe tener al menos {{photos}} fotos. Añade las que faltan.",
    "fotokit_miniscrap-warning": "Cada FotoKit debe tener al menos {{photos}} fotos. Añade las que faltan.",
    "print_classic_with_border-title": "Revelados con borde",
    "all-products-project-description": "Todos los productos de este proyecto"
  },
  "modal-cut-alert": {
    "title": "Algunas fotos se cortarán",
    "description": "Te recomendamos revisar bien los encuadres antes de continuar",
    "review": "Revisar",
    "continue": "Continuar"
  },
  "badge-crop-alert": {
    "cuts-check": "Revisar recortes"
  },
  "modal-cut-confirmation-alert": {
    "title": "¿Confirmas todos los encuadres?",
    "description": "Al confirmar, aceptas los recortes que se aplicarán a tus fotos.",
    "review": "Revisar",
    "continue": "Confirmar",
    "title-confirm": "¿Confirmas todos los encuadres?",
    "title-later": "¿Quieres salir sin guardar los encuadres?",
    "description-confirm": "Una vez confirmado tu pedido, tus fotos se imprimirán tal y como las ves.",
    "description-later": "Una vez confirmado tu pedido, las fotos se imprimirán tal y como las ves.",
    "review-confirm": "Revisar",
    "review-later": "Revisar recortes",
    "continue-confirm": "Guardar y añadir al carrito",
    "continue-later": "Salir sin guardar"
  },
  "modal-adjust-crops": {
    "title": "Encuadre",
    "save_and_close": "Guardar y continuar",
    "go-back": "Atrás",
    "review-later": "Salir sin guardar"
  },
  "help-button": {
    "privacy": "Política de privacidad",
    "tutorial": "Ver tutorial",
    "open": ""
  },
  "orientation": {
    "horizontal": "Horizontal",
    "vertical": "Vertical"
  },
  "tutorial": {
    "step-1-text": "Aquí encontrarás las fotos que has elegido para imprimir",
    "step-1-cta": "Continuar",
    "step-2-text": "Haz clic en las fotos para seleccionarlas y personalizarlas a tu gusto",
    "step-2-cta": "Continuar",
    "step-3-text": "En este menú encontrarás las herramientas para personalizar las fotos que has seleccionado",
    "step-3-cta": "Entiendo",
    "group-text": "Aquí encontrarás las fotos que has elegido para imprimir",
    "group-cta": "Entiendo",
    "product-text": "Haz clic en las fotos para seleccionarlas y personalizarlas a tu gusto",
    "product-cta": "Continuar",
    "toolbar-text": "En este menú encontrarás las herramientas para personalizar las fotos que has seleccionado",
    "toolbar-cta": "¡Entendido!",
    "zoom-text": "Para mover mejor la foto, prueba a usar el zoom.",
    "zoom-cta": "¡Entendido!",
    "zoom-text-mobile": "Para mover mejor la foto, usa el zoom separando los dedos."
  },
  "bottom-bar": {
    "go-to-cart": "Añadir al carrito",
    "confirm": "Confirmar"
  },
  "modal-delete-all": {
    "title": "¿Quieres eliminar las fotos seleccionadas?",
    "description": "Si cambias de opinión, tendrás que añadirlos nuevamente al proyecto.",
    "description_n": "Si cambias de opinión, tendrás que añadirlos nuevamente al proyecto.",
    "review": "Cancelar",
    "confirm": "Eliminar"
  },
  "bottom-sheet-avoid-cuts": {
    "title": "Cómo evitar cortes en las fotos",
    "description": "El tamaño recomendado es el más indicado para las fotos que has seleccionado y así evitar cortes no deseados.\n\nSi prefieres otro tamaño, las fotos aparecerán recortadas, pero podrás seguir ajustando el encuadre en los pasos siguientes."
  },
  "hints": {
    "border_not_available_for_product": "El borde seleccionado no está disponible para este producto",
    "option_does_not_support_border": "La opción seleccionada no admite bordes"
  },
  "text-tool-option": {
    "title": "Texto",
    "font": "Fuente",
    "style": "Estilo",
    "alignment": "Alinear",
    "color": "Color del texto",
    "button": "Aplicar",
    "size": "Tamaño de fuente"
  },
  "modal-delete-from-drawer": {
    "title": "¿De verdad quieres eliminar esta foto?",
    "description": "Si cambias de opinión, tendrás que volver a añadirlo al proyecto.",
    "abort": "Cancelar",
    "confirm": "Confirmar"
  },
  "badge-min-products": {
    "missing-products": "Cantidad mínima no alcanzada"
  },
  "modal-over-limit-products": {
    "title": "Has excedido el límite máximo de {{limit}} fotos para tu Happy Case.",
    "description": "¿Quieres añadir otra caja o eliminar algunas fotos?",
    "remove": "Eliminar algunas fotos",
    "add": "Comprar otra caja",
    "title_happy_case_classic": "Has excedido el límite máximo de {{limit}} fotos para tu Happy Case.",
    "title_happy_case_vintage": "Has excedido el límite máximo de {{limit}} fotos para tu Happy Case.",
    "title_fotokit_homedecor": "Has superado el límite máximo de {{limit}} fotos para el FotoKit.",
    "title_fotokit_miniscrap": "Has superado el límite máximo de {{limit}} fotos para el FotoKit.",
    "description_happy_case_classic": "¿Quieres añadir otra caja o eliminar algunas fotos?",
    "description_happy_case_vintage": "¿Quieres añadir otra caja o eliminar algunas fotos?",
    "description_fotokit_homedecor": "¿Quieres añadir otro FotoKit o eliminar algunas fotos?",
    "description_fotokit_miniscrap": "¿Quieres añadir otro FotoKit o eliminar algunas fotos?",
    "add_happy_case_classic": "Comprar otra caja",
    "add_happy_case_vintage": "Comprar otra caja",
    "add_fotokit_homedecor": "Añadir otro FotoKit",
    "add_fotokit_miniscrap": "Añadir otro FotoKit"
  },
  "modal-min-products-alert": {
    "title": "No se ha alcanzado la cantidad mínima de fotos",
    "description": "Añade las fotos que faltan para completar la caja.",
    "cta": "Volver al editor",
    "description_happy_case_classic": "Añade las fotos que faltan para completar la caja y añadirla al carrito.",
    "description_happy_case_vintage": "Añade las fotos que faltan para completar la caja y añadirla al carrito.",
    "description_fotokit_homedecor": "Añade las fotos que faltan para completar el FotoKit y añadirlo al carrito.",
    "description_fotokit_miniscrap": "Añade las fotos que faltan para completar el FotoKit y añadirlo al carrito."
  },
  "upload-smartphone": {
    "title": "Selecciona las fotos de la galería de tu móvil",
    "description": "para seguir creando tu proyecto en el ordenador",
    "cta": "Seleccionar fotos",
    "uploading-title": "Estamos subiendo tus fotos",
    "uploading-description": "No cierres la aplicación, solo tardará unos instantes",
    "uploaded-title": "Tus fotos se han subido al ordenador",
    "uploaded-description": "Si quieres añadir más, haz clic abajo. Si no, puedes cerrar esta página.",
    "uploaded-cta": "Añadir más fotos",
    "error-retry-title": "Error al subir",
    "error-retry-description": "Comprueba tu conexión a internet e inténtalo de nuevo. Si el problema persiste, contacta con nuestro soporte.",
    "error-fatal-title": "Algo salió mal.",
    "error-fatal-description": "Vuelve a la pantalla del código QR, actualiza la página e inténtalo de nuevo.",
    "upload-again-title": "Subida interrumpida",
    "upload-again-description": "No se han podido subir todas las fotos.\nComprueba tu conexión a internet e inténtalo de nuevo. Si el problema persiste, contacta con nuestro soporte.",
    "upload-again-cta": "Volver a seleccionar fotos",
    "retry": "Reintentar",
    "upload-corrupted-title": "No se pudieron subir uno o más archivos.",
    "upload-corrupted-description-tail-counter": " y otros {{counter_file}} pueden estar dañados o en un formato no compatible.",
    "upload-corrupted-description-tail": " es posible que estén dañados o en un formato no compatible.",
    "upload-corrupted-description-head": "Los siguientes archivos: ",
    "upload-corrupted-url": "Mostrar lista completa",
    "upload-corrupted-cta": "Seleccionar fotos"
  },
  "upload-family-friends": {
    "title": "Selecciona y comparte tus fotos!",
    "description": "Contribuirás a mantener tus recuerdos a salvo para siempre.",
    "cta": "Seleccionar fotos",
    "uploading-title": "Estamos subiendo tus fotos",
    "uploading-description": "No cierres la aplicación, solo tardará un momento.",
    "uploaded-title": "¡Subida completada! ¡Avísales de que has completado la misión!",
    "uploaded-description": "Gracias por tu valiosa contribución.",
    "uploaded-cta": "Añadir más fotos",
    "redirect": "¿Quieres guardar recuerdos también?",
    "redirect-cta": "Descubre nuestros productos",
    "error-retry-title": "Error al subir",
    "error-retry-description": "Comprueba tu conexión a internet e inténtalo de nuevo. Si el problema persiste, contacta con nuestro soporte.",
    "error-fatal-title": "Algo salió mal.",
    "error-fatal-description": "Vuelve a la pantalla del código QR, actualiza la página e inténtalo de nuevo.",
    "upload-again-title": "Subida interrumpida",
    "upload-again-description": "No se han podido subir todas las fotos.\nComprueba tu conexión a internet e inténtalo de nuevo. Si el problema persiste, contacta con nuestro soporte.",
    "upload-again-cta": "Volver a seleccionar fotos",
    "retry": "Reintentar",
    "upload-corrupted-title": "No se pudieron subir uno o más archivos.",
    "upload-corrupted-description-tail-counter": " y otros {{counter_file}} pueden estar dañados o en un formato no compatible.",
    "upload-corrupted-description-tail": " es posible que estén dañados o en un formato no compatible.",
    "upload-corrupted-description-head": "Los siguientes archivos: ",
    "upload-corrupted-url": "Mostrar lista completa",
    "upload-corrupted-cta": "Seleccionar fotos"
  },
  "modal-picker-smartphone": {
    "upload": "Sube fotos desde tu móvil",
    "step-1-title": "Escanea el código QR",
    "step-1-description": "con la cámara de tu móvil",
    "step-2-title": "Selecciona las fotos",
    "step-2-description": "desde la galería de tu móvil",
    "step-3-title": "Mira aquí la vista previa de tus fotos",
    "step-3-description": "luego haz clic en confirmar",
    "troubleshooting": "¿Problemas con el código QR?\nCopia y pega este enlace en el navegador de tu móvil",
    "copy-cta": "Copiar enlace",
    "connected-title": "¡Conexión activa!",
    "connected-description": "Ahora puedes seleccionar las fotos de la galería de tu móvil. Las verás aquí en la vista previa.",
    "copied": "Enlace copiado"
  },
  "modal-picker-family-friends": {
    "upload": "Sube las fotos de tus amigos y familiares",
    "step-1-title": "Copia y comparte el enlace con los tuyos",
    "step-1-description": "por SMS, WhatsApp, e-mail...",
    "step-2-title": "Pídeles que suban las fotos y que te avisen",
    "step-2-description": "porque el enlace caduca en pocos días",
    "step-3-title": "Mira aquí la vista previa de tus fotos",
    "step-3-description": "luego haz clic en confirmar",
    "copy-cta": "Copiar enlace",
    "share-cta": "Compartir enlace",
    "share-message": "Invitación a subir fotos al proyecto",
    "or-choice": "O bien"
  },
  "modal-below-limit-products": {
    "title": "Este producto requiere un mínimo de {{limit}} fotos.",
    "description": "Añade las fotos que faltan para completar la caja.",
    "cta": "Añadir ahora",
    "close": "Añadir más tarde",
    "description_happy_case_classic": "Añade las fotos que faltan para completar la caja.",
    "description_happy_case_vintage": "Añade las fotos que faltan para completar la caja.",
    "description_fotokit_homedecor": "Añade las fotos que faltan para completar el FotoKit.",
    "description_fotokit_miniscrap": "Añade las fotos que faltan para completar el FotoKit."
  },
  "modal-upload-error": {
    "title": "Archivos no cargados",
    "cta": "Vale, gracias",
    "description": "Podría estar dañado o en un formato no compatible. Por favor, verifica e inténtalo de nuevo."
  },
  "formats-content": {
    "print_classic": {
      "7x00": "Mantiene las proporciones originales de la foto",
      "7x_PANORAMIC": "Mantiene las proporciones originales de la foto",
      "10x10": "Cuadrado",
      "10x13": "Formato predeterminado de los smartphones",
      "10x15": "Estándar para marcos y álbumes de fotos",
      "10x_PANORAMIC": "Mantiene las proporciones originales de la foto",
      "10x00": "Mantiene las proporciones originales de la foto",
      "12x12": "Cuadrado",
      "12x16": "Formato predeterminado de los smartphones",
      "12x18": "Estándar para marcos y álbumes de fotos",
      "12x00": "Mantiene las proporciones originales de la foto",
      "12x_PANORAMIC": "Mantiene las proporciones originales de la foto",
      "13x13": "Cuadrado",
      "13x17": "Formato predeterminado de los smartphones",
      "13x17.33": "Formato predeterminado de los smartphones",
      "13x19": "Estándar para marcos y álbumes de fotos",
      "13x19.5": "Estándar para marcos y álbumes de fotos",
      "13x_PANORAMIC": "Mantiene las proporciones originales de la foto",
      "13x00": "Mantiene las proporciones originales de la foto",
      "15x15": "Cuadrado",
      "15x20": "Formato predeterminado de los smartphones",
      "15x22.5": "Estándar para marcos y álbumes de fotos",
      "15x22": "Estándar para marcos y álbumes de fotos",
      "15x_PANORAMIC": "Mantiene las proporciones originales de la foto",
      "15x00": "Mantiene las proporciones originales de la foto"
    },
    "poster": {
      "20x20": "",
      "20x27": "",
      "20x30": "",
      "30x40": "",
      "30x45": "",
      "40x40": "",
      "40x50": "",
      "40x60": "",
      "50x50": "",
      "50x70": "",
      "50x75": ""
    },
    "print_vintage": {
      "8x10": "Pequeño tamaño, grandes emociones que guardar.",
      "12x15": "El tamaño perfecto para revivir cada momento con calidez.",
      "20x25": "Un recuerdo que llena el espacio e ilumina la habitación."
    },
    "print_pro": {
      "10x13": "Formato predeterminado de los smartphones",
      "10x15": "Estándar para marcos y álbumes de fotos",
      "12x16": "Formato predeterminado de los smartphones",
      "12x18": "Estándar para marcos y álbumes de fotos",
      "13x17.33": "Formato predeterminado de los smartphones",
      "13x17": "Formato predeterminado de los smartphones",
      "13x19": "Estándar para marcos y álbumes de fotos",
      "13x19.5": "Estándar para marcos y álbumes de fotos",
      "15x20": "Formato predeterminado de los smartphones",
      "15x22.5": "Estándar para marcos y álbumes de fotos",
      "15x22": "Estándar para marcos y álbumes de fotos"
    },
    "poster_pro": {
      "20x20": "",
      "18x24": "",
      "20x25": "",
      "24x24": "",
      "20x30": "",
      "24x30": "",
      "24x36": "",
      "30x30": "",
      "30x45": "",
      "30x40": "",
      "35x35": "",
      "40x40": "",
      "35x50": "",
      "30x60": "",
      "40x50": "",
      "50x50": "",
      "40x60": "",
      "50x70": "",
      "50x60": "",
      "50x75": "",
      "60x80": "",
      "70x100": ""
    },
    "happy_case_classic": {
      "one": "",
      "other": ""
    },
    "happy_case_vintage": {
      "one": "",
      "other": ""
    },
    "fotokit_homedecor": {
      "one": "",
      "other": ""
    },
    "fotokit_miniscrap": {
      "one": "",
      "other": ""
    },
    "suggested": "Ideal para evitar cortes en tus fotos",
    "print_classic_with_border": {
      "7x00": "Mantiene las proporciones originales de la foto",
      "7x_PANORAMIC": "Mantiene las proporciones originales de la foto",
      "10x10": "Cuadrado",
      "10x13": "Formato predeterminado de los smartphones",
      "10x15": "Estándar para marcos y álbumes de fotos",
      "10x_PANORAMIC": "Mantiene las proporciones originales de la foto",
      "10x00": "Mantiene las proporciones originales de la foto",
      "12x12": "Cuadrado",
      "12x16": "Formato predeterminado de los smartphones",
      "12x18": "Estándar para marcos y álbumes de fotos",
      "12x00": "Mantiene las proporciones originales de la foto",
      "12x_PANORAMIC": "Mantiene las proporciones originales de la foto",
      "13x13": "Cuadrado",
      "13x17": "Formato predeterminado de los smartphones",
      "13x17.33": "Formato predeterminado de los smartphones",
      "13x19": "Estándar para marcos y álbumes de fotos",
      "13x19.5": "Estándar para marcos y álbumes de fotos",
      "13x_PANORAMIC": "Mantiene las proporciones originales de la foto",
      "13x00": "Mantiene las proporciones originales de la foto",
      "15x15": "Cuadrado",
      "15x20": "Formato predeterminado de los smartphones",
      "15x22.5": "Estándar para marcos y álbumes de fotos",
      "15x22": "Estándar para marcos y álbumes de fotos",
      "15x_PANORAMIC": "Mantiene las proporciones originales de la foto",
      "15x00": "Mantiene las proporciones originales de la foto"
    }
  },
  "unsupportedEnv": {
    "title": "{{env}} no actualizado",
    "description": "La versión de tu {{env}} no es compatible.\nActualízalo a la última versión para seguir usando el editor sin problemas.",
    "incognitoTitle": "Modo incógnito no compatible",
    "incognitoDescription": "Abre el editor en una ventana normal para continuar.\nSi estabas abriendo un proyecto guardado, no lo has perdido:\npodrás encontrarlo accediendo al editor con una navegación estándar.",
    "noAvailableSpaceTitle": "Almacenamiento lleno",
    "noAvailableSpaceDescription": "Libera espacio en tu dispositivo eliminando fotos o aplicaciones que no uses y recarga la página.",
    "noAvailableSpaceCta": "Recargar página"
  },
  "toast-share-photos": {
    "title": "Nuevas fotos subidas",
    "description": "¿Quieres verlas?",
    "cta-confirm": "Ver",
    "cta-decline": "Ahora no",
    "description-single": "¿Quieres verlo?"
  },
  "group-action-bar-v3": {
    "select": "Seleccionar todo",
    "deselect": "Deseleccionar todo",
    "selected": " foto seleccionada",
    "selected_plural": " fotos seleccionadas",
    "delete-selected": "Eliminar seleccionadas",
    "duplicate-selected": "Duplicar seleccionadas",
    "add": "Añadir más fotos",
    "box-style": "Cambiar estilo",
    "box-style-hint": "Cambiar estilo de caja",
    "delete-selected-short": "Eliminar",
    "duplicate-selected-short": "Duplicar",
    "add-disabled": "Subiendo fotos"
  },
  "modal-network": {
    "title": "No hay conexión a Internet",
    "description": "Verifica tu conexión Wi-Fi o la configuración de red.",
    "sub-description-head": "Tu proyecto se guardará automáticamente en la sección",
    "sub-description-tail": "Tus proyectos",
    "cta": "Vale, gracias",
    "sub-description": "Tu proyecto se guardará automáticamente en la sección"
  },
  "group-suffix": {
    "10x13": "10x13",
    "13x19.5": "13x19",
    "8x10": "8x10",
    "15x22.5": "15x22",
    "20x27": "20x27",
    "13x13": "13x13",
    "20x30": "20x30",
    "40x50": "40x50",
    "50x50": "50x50",
    "12x15": "12x15",
    "15x15": "15x15",
    "20x25": "20x25",
    "13x17.33": "13x17",
    "12x18": "12x18",
    "40x40": "40x40",
    "40x60": "40x60",
    "15x20": "15x20",
    "50x70": "50x70",
    "50x60": "50x60",
    "12x12": "12x12",
    "50x75": "50x75",
    "10x10": "10x10",
    "7x10": "7x10",
    "30x45": "30x45",
    "10x15": "10x15",
    "12x16": "12x16",
    "30x40": "30x40",
    "20x20": "20x20",
    "8x_PANORAMIC": "8x",
    "12x_PANORAMIC": "12x",
    "30x_PANORAMIC": "30x",
    "20x_PANORAMIC": "20x",
    "13x_PANORAMIC": "13x",
    "7x_PANORAMIC": "7x",
    "10x_PANORAMIC": "10x",
    "40x_PANORAMIC": "40x",
    "15x_PANORAMIC": "15x",
    "50x_PANORAMIC": "50x",
    "13x19": "13x19",
    "15x22": "15x22",
    "13x17": "13x17",
    "8x00": "8x",
    "12x00": "12x",
    "30x00": "30x",
    "20x00": "20x",
    "13x00": "13x",
    "7x00": "7x",
    "10x00": "10x",
    "40x00": "40x",
    "15x00": "15x",
    "50x00": "50x",
    "18x24": "18x24",
    "24x24": "24x24",
    "24x30": "24x30",
    "24x36": "24x36",
    "30x30": "30x30",
    "35x35": "35x35",
    "35x50": "35x50",
    "30x60": "30x60",
    "60x80": "60x80",
    "70x100": "70x100"
  },
  "modal-new-version-available": {
    "title": "Nueva versión disponible",
    "description": "Recarga la página para continuar con la última versión.\nEl proyecto se guardará automáticamente en la sección <bold>Tus proyectos<\/bold>.",
    "cta": "Recargar"
  },
  "zoom-image": {
    "title": "Vista previa",
    "go-back": "Volver",
    "photos": "{{counter}} fotos"
  },
  "bottom-sheet-group-tabs": {
    "title": ""
  },
  "modal-max-products-alert": {
    "title": "Has superado el límite de fotos",
    "description": "Elimina las fotos sobrantes para continuar.",
    "cta": "Volver al editor",
    "description_happy_case_classic": "Elimina las fotos sobrantes para completar tu caja y añadirla al carrito.",
    "description_happy_case_vintage": "Elimina las fotos sobrantes para completar tu caja y añadirla al carrito.",
    "description_fotokit_homedecor": "Elimina las fotos sobrantes para completar tu FotoKit.",
    "description_fotokit_miniscrap": "Elimina las fotos sobrantes para completar tu FotoKit y añadirlo al carrito."
  },
  "modal-no-available-space": {
    "title": "Almacenamiento lleno",
    "description": "Libera espacio en tu dispositivo eliminando fotos o aplicaciones que no uses y recarga la página.",
    "cta": "Recargar página"
  },
  "modal-product-not-available": {
    "title": "Producto no disponible",
    "description-saved": "Tus cambios se han guardado. Podrás añadir el proyecto a la cesta en cuanto el producto vuelva a estar disponible.",
    "description-guest": "Tus cambios se han guardado: inicia sesión para encontrar el proyecto en la página “Tus proyectos”. Podrás añadirlo a la cesta en cuanto el producto vuelva a estar disponible.",
    "continue-editing": "Seguir editando",
    "back-to-projects": "Volver a proyectos",
    "login": "Iniciar sesión"
  }
}